import { useState } from 'react';
import { Box, Typography, Paper, Button, TextField, Stack } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { 
  increment, 
  decrement, 
  incrementByAmount, 
  selectCount 
} from '../store/slices/counterSlice';

const CounterPage = () => {
  const count = useAppSelector(selectCount);
  const dispatch = useAppDispatch();
  const [incrementAmount, setIncrementAmount] = useState('2');

  const handleIncrementByAmount = () => {
    const amount = Number(incrementAmount) || 0;
    dispatch(incrementByAmount(amount));
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Redux Counter Example
      </Typography>
      
      <Paper elevation={3} sx={{ p: 4, maxWidth: 500, mx: 'auto' }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography variant="h2" component="div" data-testid="count">
            {count}
          </Typography>
        </Box>
        
        <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 3 }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => dispatch(increment())}
            size="large"
          >
            Increment
          </Button>
          <Button 
            variant="contained" 
            color="secondary" 
            onClick={() => dispatch(decrement())}
            size="large"
          >
            Decrement
          </Button>
        </Stack>
        
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
          <TextField
            label="Amount"
            value={incrementAmount}
            onChange={(e) => setIncrementAmount(e.target.value)}
            type="number"
            size="small"
            sx={{ width: 100 }}
          />
          <Button 
            variant="outlined" 
            onClick={handleIncrementByAmount}
          >
            Add Amount
          </Button>
        </Box>
      </Paper>
      
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          This counter is managed by Redux Toolkit.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Check the Redux DevTools to see the state changes.
        </Typography>
      </Box>
    </Box>
  );
};

export default CounterPage;
